<template>
  <div id="app" class="text-gray">
    <Kvarea id="home" />
    <Header />
    <About id="about" />
    <Review id="review" />
    <Report id="report" />
    <Character id="character" />
    <BtnetFooter :goTop="false" />
  </div>
</template>

<script>
import Kvarea from './components/Kvarea'
import Header from './components/Header'
import About from './components/About'
import Review from './components/Review'
import Report from "./components/Report"
import Character from "./components/Character"
import BtnetFooter from "./components/BtnetFooter"

// import Icon from 'vue-awesome/components/Icon'
// import 'vue-awesome/icons/times-circle'

export default {
  name: 'App',
  components: {
    Kvarea,
    Header,
    About,
    Review,
    Report,
    Character,
    BtnetFooter,
    // 'v-icon': Icon
  },
  mounted() {
    // 調用store中的actions 取得本頁資料
    this.$store.dispatch('GETINDEXDATA');
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/earlyaccess/notosanstc.css');
@import url('https://fonts.googleapis.com/earlyaccess/cwtexfangsong.css');
@import url('https://fonts.googleapis.com/css?family=Lato:100,300,400,700,900');

html {
  font-family: 'Noto Sans TC', sans-serif, 'Microsoft JhengHei', arial;
  font-size: 1vw;
  letter-spacing: 0.1rem;
}
@media screen and (max-width: 1900px) {
  html {
    font-size: 1.1vw;
  }
}
@media screen and (max-width: 1440px) {
  html {
    font-size: 1.3vw;
  }
}
@media screen and (max-width: 1024px) {
  html {
    font-size: 1.6vw;
  }
}
@media screen and (max-width: 768px) {
  html {
    font-size: 2vw;
  }
}
@media screen and (max-width: 640px) {
  html {
    font-size: 3vw;
  }
}
@media screen and (max-width: 480px) {
  html {
    font-size: 4.2vw;
  }
}
@media screen and (max-width: 320px) {
  html {
    font-size: 4.5vw;
  }
}
</style>
